import { DateTime } from "luxon";
import {
  ACTIVITY_SEARCH_FORM_UPDATE,
  ACTIVITY_SEARCH_FORM_INIT,
  SINGLE_ACTIVITY_SEARCH_LOADING,
  SINGLE_ACTIVITY_SEARCH_IDLE,
  SINGLE_ACTIVITY_SEARCH_CHANGE,
  SINGLE_ACTIVITY_SEARCH_UPDATE,
  SINGLE_ACTIVITY_SELECTED_LOADING,
  SINGLE_ACTIVITY_SELECTED_IDLE,
  SINGLE_ACTIVITY_SELECTED_CHANGE,
  SINGLE_ACTIVITY_SELECTED_UPDATE,
  ACTIVITY_SEARCH_FILTERS_INIT,
  ACTIVITY_SEARCH_FILTERS_CHANGE,
  ACTIVITY_SEARCH_FILTERS_UPDATE,
  SINGLE_ACTIVITY_SEARCH_RESET,
  SINGLE_ACTIVITY_SELECTED_RESET,
} from "../actions/search/types";

const ActivitySearchFormInitial = {
  adults: 2,
  children: 0,
  children_ages: [],
  date_from: DateTime.now().plus({ days: 1 }).toISODate(),
  date_to: DateTime.now().plus({ days: 7 }).toISODate(),
  latitude: 0,
  longitude: 0,
  radius: 50,
  destination_code: [],
  destination_meta: {},
  search_session_id: null,
};
export const ActivitySearchForm = (
  state = ActivitySearchFormInitial,
  action
) => {
  switch (action.type) {
    case ACTIVITY_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case ACTIVITY_SEARCH_FORM_INIT: {
      return ActivitySearchFormInitial;
    }
    default:
      return state;
  }
};

const ActivitySearchFiltersInitial = {
  name: "",
  budget: [0, 1],
  categories: [],
  features: [],
  order_by: "",
};
export const ActivitySearchFilters = (
  state = ActivitySearchFiltersInitial,
  action
) => {
  switch (action.type) {
    case ACTIVITY_SEARCH_FILTERS_INIT: {
      return ActivitySearchFiltersInitial;
    }
    case ACTIVITY_SEARCH_FILTERS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case ACTIVITY_SEARCH_FILTERS_UPDATE: {
      const { filters } = action;
      return { ...state, ...filters };
    }
    default:
      return state;
  }
};

const ActivitySearchReducerInitial = {
  activities: {},
  loading: true,
  failed: false,
};
export const ActivitySearchReducer = (
  state = ActivitySearchReducerInitial,
  action
) => {
  switch (action.type) {
    case SINGLE_ACTIVITY_SEARCH_LOADING: {
      return { ...state, loading: true };
    }
    case SINGLE_ACTIVITY_SEARCH_IDLE: {
      return { ...state, loading: false };
    }
    case SINGLE_ACTIVITY_SEARCH_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SINGLE_ACTIVITY_SEARCH_UPDATE: {
      const { activities, loading } = action;
      return { ...state, activities, loading };
    }
    case SINGLE_ACTIVITY_SEARCH_RESET: {
      return ActivitySearchReducerInitial;
    }
    default:
      return state;
  }
};

const ActivitySelectedInitial = {
  activity: {},
  session_id: "",
  loading: true,
  failed: false,
};
export const ActivitySelected = (state = ActivitySelectedInitial, action) => {
  switch (action.type) {
    case SINGLE_ACTIVITY_SELECTED_LOADING: {
      return { ...state, loading: true };
    }
    case SINGLE_ACTIVITY_SELECTED_IDLE: {
      return { ...state, loading: false };
    }
    case SINGLE_ACTIVITY_SELECTED_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SINGLE_ACTIVITY_SELECTED_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case SINGLE_ACTIVITY_SELECTED_RESET: {
      return ActivitySelectedInitial;
    }
    default:
      return state;
  }
};
